export const NO_VALUE = '__no_value__';
export const NO_VALUE_LABEL = '(no value)';

const byLabel = (a, b) => a.label.localeCompare(b.label);
const byName = (a, b) => a.name.localeCompare(b.name);

export const OWNERSHIP_TYPES = [
  { value: 'owned', label: 'Owned' },
  { value: 'customer', label: 'Customer' },
  { value: 'supplier', label: 'Supplier' },
  { value: '3pl', label: '3PL' },
  { value: 'public', label: 'Public' },
].sort(byLabel);

export const OWNERSHIP_FILTER_OPTIONS = [
  { value: NO_VALUE, label: NO_VALUE_LABEL },
  ...OWNERSHIP_TYPES,
];

/** Each standard type followed by the account's custom types under it. */
export const placeTypeOptions = (placeTypes) => {
  const toOption = (type) => ({
    value: type.slug,
    label: type.name,
    isCustom: type.is_custom,
  });
  const childrenOf = (slug) =>
    placeTypes.filter((type) => type.parent === slug).sort(byName);

  return placeTypes
    .filter((type) => !type.is_custom)
    .sort(byName)
    .flatMap((type) => [
      toOption(type),
      ...childrenOf(type.slug).map(toOption),
    ]);
};

export const placeTypeLabel = (placeTypes, slug) =>
  placeTypes.find((item) => item.slug === slug)?.name ?? '';

export const placeTypeParents = (placeTypes) =>
  Object.fromEntries(
    placeTypes
      .filter((type) => type.parent)
      .map((type) => [type.slug, type.parent]),
  );

export const ownershipTypeLabel = (value) =>
  OWNERSHIP_TYPES.find((option) => option.value === value)?.label ?? '';
